import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ImageIcon, ShareIcon, PaletteIcon, PlaneIcon, UsersIcon, SunIcon } from 'lucide-react';
export function Benefits() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  const benefits = [{
    icon: ImageIcon,
    title: 'Portfolio-Content',
    description: 'Hochwertige Bilder aus einzigartigen internationalen Locations für dein Portfolio.'
  }, {
    icon: ShareIcon,
    title: 'Social Media Content',
    description: 'Content, der auf Instagram, Patreon und anderen Plattformen heraussticht.'
  }, {
    icon: PaletteIcon,
    title: 'Kreativer Austausch',
    description: 'Arbeite mit Gleichgesinnten zusammen und lass dich von neuen Perspektiven inspirieren.'
  }, {
    icon: PlaneIcon,
    title: 'Premium Reiseerlebnis',
    description: 'Ausgewählte Unterkünfte, durchdachte Planung und unvergessliche Momente.'
  }, {
    icon: UsersIcon,
    title: 'Networking',
    description: 'Baue wertvolle Kontakte zu Models, Fotografen und Content Creators auf.'
  }, {
    icon: SunIcon,
    title: 'Inspirierende Locations',
    description: 'Von versteckten Buchten bis zu historischen Altstädten — Orte, die begeistern.'
  }];
  return <section className="py-24 md:py-32 px-6 bg-[#f5f5f7]" data-id="element-87">
      <div className="max-w-7xl mx-auto" data-id="element-88">
        <div className="text-center mb-16" data-id="element-89">
          <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-90">
            Was dich erwartet
          </span>
          <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e]" data-id="element-91">
            Dein Erlebnis. Dein Content. <br className="hidden md:block" data-id="element-92" />
            <span className="italic text-[#8a8a9a]" data-id="element-93">Deine Community.</span>
          </h2>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-94">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white border border-[#e2e2e6] p-8 rounded-xl hover:border-brand-accent/30 shadow-sm hover:shadow-md transition-all duration-500 group" data-id="element-95">
              <div className="w-12 h-12 rounded-full bg-[#f5f5f7] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500" data-id="element-96">
                <benefit.icon className="w-5 h-5 text-brand-accent" data-id="element-97" />
              </div>
              <h3 className="text-xl font-heading text-[#1a1a2e] mb-3" data-id="element-98">
                {benefit.title}
              </h3>
              <p className="text-[#4a4a5a] font-light text-sm leading-relaxed" data-id="element-99">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}